import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild , Router } from "@angular/router";

@Injectable()
export class PatientPortalDashboardAccessGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router
  ) { }

  canActivate() {
    let loggedPatient = JSON.parse(sessionStorage.getItem("User"));

    let sessionToken = sessionStorage.getItem("AccessToken");

    if (!!sessionToken && loggedPatient.Role === "patient") {
      return true;
    } else {
      this.router.navigate(["/patient-portal/login"]);
      return false;
    }
  }

  canActivateChild() {
    return this.canActivate();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/patient-portal/patient-portal-dashboard-access.guard.ts